import { LocationEntity } from '@peritasai/repository';
import { LocationResponseDtoSchema } from '@peritasai/types';


const STORAGE_KEY = 'periverse.assignToCase.selectedLocation';

const isBrowser = () => typeof window !== 'undefined';

export const readStoredLocation = (): LocationEntity | null => {
  if (!isBrowser()) return null;

  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return new LocationEntity(LocationResponseDtoSchema.parse(JSON.parse(raw)));
  } catch (error) {
    console.warn('Failed to read stored assign-to-case location', error);
    return null;
  }
};

export const writeStoredLocation = (location: LocationEntity) => {
  if (!isBrowser()) return;

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(location.toDTO()));
  } catch (error) {
    console.warn('Failed to persist assign-to-case location', error);
  }
};

export const clearStoredLocation = () => {
  if (!isBrowser()) return;

  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear stored assign-to-case location', error);
  }
};
